import React from 'react';
import graphql from 'graphql';
import styled from 'styled-components';

import GalleryFilter from '../components/GalleryFilter';
import { Heading, Paragraph } from '../components/Styling';
import { Grid } from '../components/Grid';
import { GridElement } from '../components/GridElement';
import { FullscreenVideo } from '../components/FullscreenVideo';
import { Spinner } from '../components/Spinner';

class UnstyledIndexPage extends React.Component {
  constructor(props) {
    super(props);

    let categories = [];
    this.props.data.workPosts.edges.forEach(post => {
      if (!post.node.frontmatter.hidden && post.node.frontmatter.category)
        post.node.frontmatter.category.split(/\s*,\s*/).forEach(e => {
          if (categories.indexOf(e) === -1) categories.push(e);
        });
    });

    this.state = {
      gridElementHover: false,
      categories: categories,
      currentCategory: 'all',
      gridElementActive: false,
      activeElement: null
    };

    this.setHover = this.setHover.bind(this);
    this.setCategory = this.setCategory.bind(this);
    this.toggleActive = this.toggleActive.bind(this);
  }

  setHover = value => {
    this.setState({ gridElementHover: value });
  };

  setCategory = category => {
    this.setState({ currentCategory: category });
  };

  toggleActive = element => {
    this.setState({ gridElementActive: !this.state.gridElementActive, activeElement: element });
  };

  shouldComponentUpdate() {
    if (!this.props.transition) return false;
    else return true;
  }

  render() {
    if (!this.props.transition || this.props.transition && this.props.transition.status === 'exited')
      return <Spinner />;
    else {
      const indexPage = this.props.data.indexPage.edges[0].node;
      const { edges: posts } = this.props.data.workPosts;
      const { edges: images } = this.props.data.images;

      return (
        <div
          style={this.props.transition && this.props.transition.style}
          className={this.props.className}
          onClick={() => {
            if (this.state.gridElementActive) this.toggleActive();
          }}
        >
          <Heading>{indexPage.frontmatter.title}</Heading>
          <Paragraph onIndex>{indexPage.frontmatter.subtitle}</Paragraph>
          <GalleryFilter
            handleClick={this.setCategory}
            currentCategory={this.state.currentCategory}
            categories={this.state.categories}
          />
          <Grid dim={this.state.gridElementActive}>
            {posts
              .filter(
                post =>
                  !post.node.frontmatter.hidden &&
                  (post.node.frontmatter.category &&
                    post.node.frontmatter.category.split(/\s*,\s*/).indexOf(this.state.currentCategory) !== -1 ||
                    this.state.currentCategory === 'all')
              )
              .map(({ node: post }) => {
                return (
                  <GridElement
                    active={
                      this.state.gridElementActive &&
                      this.state.activeElement.videoShort === post.frontmatter.videoShort
                    }
                    fade={this.state.gridElementHover}
                    images={images}
                    toggleActive={this.toggleActive}
                    toggleHover={this.setHover}
                    key={post.frontmatter.videoShort}
                    data={post.frontmatter}
                  />
                );
              })}
          </Grid>
          {this.state.gridElementActive && <FullscreenVideo element={this.state.activeElement} />}
        </div>
      );
    }
  }
}

const IndexPage = styled(UnstyledIndexPage)`
  flex: 1;
`;

export default IndexPage;

export const pageQuery = graphql`
  query WorkPageQuery {
    workPosts: allMarkdownRemark(
      sort: { fields: [frontmatter___year], order: DESC }
      filter: { frontmatter: { templateKey: { eq: "work-post" } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            category
            client
            descriptionShort
            hidden
            image
            path
            priority
            templateKey
            title
            video
            videoShort
            year
          }
        }
      }
    }
    indexPage: allMarkdownRemark(filter: { frontmatter: { templateKey: { eq: "index" } } }) {
      edges {
        node {
          frontmatter {
            subtitle
            title
          }
        }
      }
    }
    images: allFile(filter: { internal: { mediaType: { regex: "/(image)/" } } }) {
      edges {
        node {
          name
          childImageSharp {
            sizes(maxWidth: 660) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js